import React, { Component } from "react"
import { Redirect } from "react-router-dom"
import { Query } from "react-apollo"
import { Helmet } from "react-helmet"
import PDFView from "../../components/PDFView"
import Button from "../../components/Button"
import ApolloQueryHandler from "../../shared/apolloQueryHandler"
import qs from "qs"
import { showDownloadBtnForTrialUser } from "../../shared/helpers"

import PRODUCT_FILE from "../../graphql/getProductFile.graphql"

import "./viewProduct.scss"

import ReportFeedback from "./ReportFeedback"

class ViewProduct extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    let { product } = this.props.data

    this.props.trackEvent("Viewed report", {
      productName: product.name,
      productId: product.id,
      productType: product.proprietaryDataset,
      file: product.files.length && product.files[0].name,
    })
    this.props.trackPage("View Report", {
      productName: product.name,
      productId: product.id,
      productType: product.proprietaryDataset,
      file: product.files.length && product.files[0].name,
    })
  }

  _renderMP4View = (file, product) => {
    return (
      <div className="video-container">
        <video autoPlay={false} controls style={{ maxHeight: "100%" }}>
          <source src={product.videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <h2>
          {product.name}
          {file.name ? ` - ${file.name}` : ""}
        </h2>
      </div>
    )
  }

  onDownloadClick = (file) => {
    let { product } = this.props.data

    this.props.trackEvent("Downloaded report", {
      productName: product.name,
      productId: product.id,
      productType: product.proprietaryDataset,
      file: file.name,
    })
  }

  goBack = (e) => {
    e.preventDefault()
    this.props.history.goBack()
  }

  goHome = (e) => {
    e.preventDefault()
    this.props.history.push("/")
  }

  render = () => {
    let {
      match,
      data: { product },
    } = this.props
    let file = product.files && product.files.length > 0 && product.files[0]

    const showDownload = showDownloadBtnForTrialUser(
      this.props.data.viewer,
      product.isPurchased,
      product.free
    )

    if (!file) {
      return <Redirect to={`/marketplace/${match.params.slug}`} />
    }

    let view

    switch (file.filetype) {
      case "pdf":
        view = <PDFView url={file.url} withCredentials={true} />
        break
      case "mp4":
      case "mp3":
        view = this._renderMP4View(file, product)
        break
      default:
        view = (
          <div>Unable to load files of this type. Please download to view.</div>
        )
    }

    return (
      <div className="view-product-container">
        <Helmet>
          <title>
            {product.name} - {file.name || "View"}
          </title>
        </Helmet>
        <div className="top-options">
          <div className="links">
            <a onClick={this.goBack} data-cy="back-link">
              <span className="glyphicon glyphicon-menu-left" />
              Go Back
            </a>
            <a onClick={this.goHome}>
              <span className="glyphicon glyphicon-home" />
              Home
            </a>
          </div>

          <ReportFeedback
            feedbackType="REPORT"
            feedbackTypeId={product.id}
            title={product.productName}
          />

          {file && file.url && showDownload && (
            <Button
              data-cy="view-page-download-button"
              href={file.downloadUrl}
              download={file.downloadUrl}
              classes={["btn-download"]}
              action={() => this.onDownloadClick(file)}
              disabled={!file.downloadUrl}
            >
              <span className="glyphicon glyphicon-download-alt" />
            </Button>
          )}
        </div>
        {view}
      </div>
    )
  }
}

const ViewProductWithData = (componentProps) => {
  let productSlug = componentProps.match.params.slug
  let { item } = qs.parse(componentProps.location.search, {
    ignoreQueryPrefix: true,
  })

  return (
    <Query
      query={PRODUCT_FILE}
      variables={{
        productSlug,
        item: item && parseInt(item),
        queryString: componentProps.location.search,
      }}
      fetchPolicy="network-only"
    >
      {(queryProps) => (
        <ApolloQueryHandler {...componentProps} {...queryProps}>
          {(props) => <ViewProduct {...props} item={item} />}
        </ApolloQueryHandler>
      )}
    </Query>
  )
}

export default ViewProductWithData
